

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-message.directive', ['squid']).directive('xoMessage', function ($timeout, $loader, $rootScope) {
        return {
            scope: {
                message: '=' // Expected type - {msgs: [], type: "info|error|success|warning"}
            },
            template: template,
            link: function link(scope, element, attrs) {

                // Hide and show the alerts so that messages can be registered by
                // screen reader even if they are repeats. Uses $timeout to
                // wait for DOM before showing alerts again.
                var toggleAlert = function toggleAlert() {
                    var $alert = element.find('ul');
                    $alert.detach();
                    $timeout(function () {
                        element.find('#pageLevelErrors').append($alert);
                    });
                };

                // Toggle the alert whenever message changes by removing it and reappending it
                // to the DOM. Should fire even if message
                // is changed to the same, as assumes that the message should be reapplied.
                var cancel;
                scope.$watchCollection('message', function () {
                    if ($loader.isLoading() && !cancel) {
                        // If loading, toggle the alert after all loading calls have been made.
                        // This is so that the alert can be read by screen reader after focus
                        cancel = $rootScope.$on('allLoaded', function () {
                            cancel();
                            toggleAlert();

                            cancel = null;
                        });
                    } else {
                        toggleAlert();
                    }
                });

                scope.$on('$destroy', function () {
                    if (cancel) {
                        cancel();
                    }
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/message/directive.js
 ** module id = 185
 ** module chunks = 1
 **/